import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "card mb-25 border-0 radius-7 bg-white sales-pos-location-box" }
const _hoisted_2 = { class: "card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing" }
const _hoisted_3 = { class: "mb-15 mb-sm-0 d-sm-flex align-items-center justify-content-between" }
const _hoisted_4 = { class: "title" }
const _hoisted_5 = { class: "fw-medium text-muted fs-13 d-block mb-5 text-uppercase" }
const _hoisted_6 = { class: "card-title fw-black mb-0" }
const _hoisted_7 = {
  id: "weeklySalesChart",
  class: "chart"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_apexchart = _resolveComponent("apexchart")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.getDashboardDayCards.day_of_week_name), 1),
          _createElementVNode("h4", _hoisted_6, "(" + _toDisplayString(_ctx.getDashboardDayCards.day_of_year) + "/365)", 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createVNode(_component_apexchart, {
          type: "area",
          height: "375",
          options: _ctx.weeklySalesChart,
          series: [
            {
              name: 'UPLOADS COM SUCESSO', 
              data: Object.values(_ctx.getMetricsHours).map(hour => hour.total_success)
            },
            {
              name: 'UPLOADS COM ERRO', 
              data: Object.values(_ctx.getMetricsHours).map(hour => hour.total_error)
            },
          ]
        }, null, 8, ["options", "series"])
      ])
    ])
  ]))
}